import { ExtendedCarItem, IExtendedBenefitsData } from '@/interfaces/cars.interfaces';
import { TNullable } from '@/interfaces/common.interfaces';

/**
 * Функция для фильтрации массива,т.к выгоды могут приходить без необходимых полей данных
 *
 * @param extendedData объект автомобиля
 * @returns отфильтрованный массив выгод
 */

const getCarBenefits = (
  extendedData: ExtendedCarItem | TNullable<ExtendedCarItem> | undefined,
) => {
  const benefits = extendedData?.data?.benefits;

  if (!benefits) {
    return [] as IExtendedBenefitsData[];
  }

  const result = benefits.filter(benefit => benefit.id && benefit.name);
  return result;
};

export default getCarBenefits;
